import { createBusinessReadService } from '../application/createBusinessReadService';
import { supabaseBusinessReadPort } from '../infrastructure/supabaseBusinessReadPort';

export const businessReadService = createBusinessReadService(supabaseBusinessReadPort);
